import { pipe } from "ramda";
// import { create } from "@most/create";
import { ajax, ajaxWithProgress } from "common/mostAjax";

const STIP_BASE_URL = process.env.REACT_APP_STIP_BASE_URL;

const getSubmissionUploadUrl = projectId =>
  `${STIP_BASE_URL}/projects/${projectId}/submissions`;

const getUploadCreationUrl = () => `${STIP_BASE_URL}/file-upload/request`;

const getAudioTypesUrl = () => `${STIP_BASE_URL}/audio-types`;

const getAgeRangesUrl = () => `${STIP_BASE_URL}/age-ranges`;

const getContributorRolesUrl = () => `${STIP_BASE_URL}/contributors/roles`;

const getCountriesUrl = () => `${STIP_BASE_URL}/geography/countries`;

const getDocumentsMediumFormatsUrl = () =>
  `${STIP_BASE_URL}/medium-formats/other-document`;

const getImageMediumFormatsUrl = () => `${STIP_BASE_URL}/medium-formats/image`;

const getProjectUrl = (programKey, projectKey, language = "en") => {
  console.log(`Program Key -> ${programKey} : Project Key -> ${projectKey}`);
  if (programKey) {
    return `${STIP_BASE_URL}/csp/${programKey}/${projectKey}?lang=${language}`;
  } else {
    return `${STIP_BASE_URL}/projects/${projectKey}?lang=${language}`;
  }
};

const getSubdivisionsUrl = countryCode =>
  `${STIP_BASE_URL}/geography/countries/${countryCode}/subdivisions`;

const getVideoRatingsUrl = () => `${STIP_BASE_URL}/ratings`;

const getSubmissionTypesUrl = () => `${STIP_BASE_URL}/submission-types`;

export const fetchAudioTypes = pipe(getAudioTypesUrl, ajax);

export const fetchAgeRanges = pipe(getAgeRangesUrl, ajax);

export const fetchContributorRoles = pipe(getContributorRolesUrl, ajax);

export const fetchCountries = pipe(getCountriesUrl, ajax);

export const fetchDocumentMediumFormats = pipe(
  getDocumentsMediumFormatsUrl,
  ajax,
);

export const fetchImageMediumFormats = pipe(getImageMediumFormatsUrl, ajax);

export const fetchProject = pipe(getProjectUrl, ajax);

export const fetchSubdivisions = pipe(getSubdivisionsUrl, ajax);

export const fetchVideoRatings = pipe(getVideoRatingsUrl, ajax);

export const fetchSubmissionTypes = pipe(getSubmissionTypesUrl, ajax);

const getSubmissionsByEmailUrl = email =>
  `${STIP_BASE_URL}/submissions/email/${email}`;

export const fetchSubmissionsByEmail = email =>
  ajax(getSubmissionsByEmailUrl(email));

// const asyncDelayedCallbacks = (
//   remainingCalls,
//   delay,
//   addCallback,
//   endCallback,
// ) => {
//   addCallback(remainingCalls);
//
//   if (remainingCalls > 0) {
//     setTimeout(() => {
//       asyncDelayedCallbacks(
//         remainingCalls - 1,
//         delay,
//         addCallback,
//         endCallback,
//       );
//     }, delay);
//   } else {
//     console.log("call the end callback");
//     endCallback();
//   }
// };
//
// const createProgressEvent = remainingCalls => {
//   return new ProgressEvent("progress", {
//     loaded: 100 - remainingCalls,
//     total: 100,
//     lengthComputable: true,
//   });
// };
//
// const fakeAjaxUpload = () => {
//   return create((add, end, error) => {
//     asyncDelayedCallbacks(
//       100,
//       100,
//       remainingCalls => {
//         add(createProgressEvent(remainingCalls));
//       },
//       () => {
//         add("done");
//         end();
//       },
//     );
//   });
// };

// export const uploadSubmission = (formData, projectId) => {
//   console.log(
//     "upload submission, submission upload url: %O",
//     getSubmissionUploadUrl(projectId),
//   );
//
//   return fakeAjaxUpload();
// };

export const uploadSubmission = (formData, projectId) =>
  ajaxWithProgress({
    method: "POST",
    url: getSubmissionUploadUrl(projectId),
    body: formData,
  });

export const createUploadUrl = fileData =>
  ajax({
    method: "POST",
    url: getUploadCreationUrl(),
    body: JSON.stringify(fileData),
    headers: {
      "Content-Type": "application/json",
    },
  });

export const uploadFile = (uploadUrl, fileBlob) =>
  ajaxWithProgress({
    method: "PUT",
    url: uploadUrl,
    body: fileBlob,
  });
